import React from "react";

const Bars3Icon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    className="h-5 w-5"
  >
    <path
      fillRule="evenodd"
      d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10zm0 5.25a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75a.75.75 0 01-.75-.75z"
      clipRule="evenodd"
    />
  </svg>
);

const CloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    className="h-5 w-5"
  >
    <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
  </svg>
);

export default function NavButtons(props: any) {
  return (
    <>
      <div className="lg:hidden">
        <span className="sr-only">Open main menu</span>
        <button
          type="button"
          onClick={() => {
            props.toggleSidebar();
          }}
        >
          {props.sidebar === true && <CloseIcon />}
          {props.sidebar === false && <Bars3Icon />}
        </button>
      </div>
      <div className="hidden lg:flex items-center">
        {props.bankLogo && (
          <img
            alt="header"
            className="w-full object-cover"
            src={`${process.env.NEXT_PUBLIC_IMAGIX_URL}/${props.bankLogo}`}
          />
        )}
      </div>
    </>
  );
}
